<template>
  <v-dialog v-model="show" max-width="800">

    <v-card class="v-dialog-video-text">
      <v-card-title class="headline">
        <h4>Conteúdo de vídeo</h4>
      </v-card-title>

      <v-card-text>

        <v-form ref="formEditVideo" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" sm="12">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Data de início"
                    outlined
                    v-bind="attrs"
                    @blur="startAt = parseDate(dateFormatted)"
                    v-on="on"
                    class="first-item"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startAt" no-title @input="menu1 = false" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="content.title"
                label="Título"
                outlined
                color="blue"
                :rules="[v => !!v || 'Preencha o título do conteúdo']"
                required>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-checkbox
                    class="checkbox-video-text"
                    v-model="content.isPublic"
                    label="Conteúdo aberto"
                    v-on="on"
                    v-bind="attrs"
                  ></v-checkbox>
                </template>
                <span style="color: #fff;" >Conteúdo aberto estará disponível para qualquer<br>pessoa visualizar, sem adquirir o curso</span>
              </v-tooltip>

            </v-col>

            <v-col cols="12" sm="12">
              <v-text-field v-model="content.summary" label="Resumo" outlined color="blue" required></v-text-field>
            </v-col>

            <v-col cols="12" sm="12">
              <v-textarea v-model="content.description" label="Descrição" outlined color="blue" rows="2"></v-textarea>
            </v-col>

            <v-row class="mx-2" v-if="content.attachments && content.attachments.length">
              <v-col cols="12" md="4" v-for="(attachment, $index) in content.attachments"
                   :key="`att${$index}`">
                <v-text-field
                  v-model="attachment.name"
                  label="Nome do arquivo"
                  outlined
                  required
                  :rules="[v => !!v || 'Preencha o nome do arquivo']"
                  prepend-inner-icon="cloud"
                  append-icon="close"
                  @click:append="removeAttachment(attachment)"
                  @click:prepend-inner="downloadAttachment(attachment)"
                  @keyup.enter="renameAttachment(attachment)"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-col cols="12" sm="12" md="4">
              <upload-btn class="px-0" block :title="btnVideo.title"
                          :color="btnVideo.color"
                          @file-update="fileVideoChanged"
                          accept="video/*"
                          :uniqueId="true">
                <template slot="icon-left" v-if="videoFile || content.vimeoId">
                  <v-icon color="white">check</v-icon>
                </template>
              </upload-btn>
            </v-col>

            <v-col cols="12" sm="12" md="4" class="text-lg-center">
              <upload-btn class="px-0" block :title="btnThumb.title"
                          :color="btnThumb.color"
                          @file-update="fileImageChanged"
                          accept="image/*"
                          :uniqueId="true">
                <template slot="icon-left" v-if="thumbFile || content.thumb">
                  <v-icon color="white">check</v-icon>
                </template>
              </upload-btn>
              <span style="font-size: 12px;">
                Melhor resolução: 1280x720px
              </span>
            </v-col>

            <!--<v-col cols="12" sm="12" md="4">
              <upload-btn class="px-0" block :title="btnPDF.title"
                          :color="btnPDF.color"
                          @file-update="filePDFChanged"
                          accept="application/pdf"
                          :uniqueId="true">
                <template slot="icon-left" v-if="pdfFile || content.pdf">
                  <v-icon color="white">check</v-icon>
                </template>

              </upload-btn>
            </v-col>-->
            <v-col cols="12" sm="12" md="4">
              <upload-btn block
                          title="Incluir anexos"
                          color="blue"
                          class="px-0"
                          @file-update="fileAttachmentsChanged"
                          multiple
                          :uniqueId="true"
                          :loading="false">
              </upload-btn>
            </v-col>

            <v-col cols="12" sm="12" mt-3 v-if="content.thumb">
              <p>Thumbnail do vídeo:</p>
              <v-img :src="content.thumb" aspect-ratio="2"></v-img>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="modal-action-custom">
        <v-row>
          <v-col cols="12" sm="12" style="text-align:right;">
            <v-btn color="red" dark @click="show = false" class="mr-2">
              Cancelar
            </v-btn>
            <v-btn color="green" dark @click="save" :loading="sending" :disabled="sending">
              Salvar
            </v-btn>
          </v-col>

          <v-col cols="12" sm="12" class="progress-custom" v-if="showProgress">
              <div class="progress-custom-bar" :style="{ width: uploadProgress + '%' }"></div>
              <p>{{ textProgress }} {{ uploadProgress }}%</p>
              <!-- <v-progress-linear
                class="my-0 white"
                color="green"
                height="20"
                :value="uploadProgress"
                v-if="showProgress"></v-progress-linear> -->
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import UploadButton from 'vuetify-upload-button'
import { faVimeo } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { convertImage } from '@/helpers'

library.add(faVimeo)

export default {
  name: 'ModalVideo',
  components: {
    'upload-btn': UploadButton
  },
  data: vm => ({
    startAt: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,

    show: true,
    btnLoadingThumbVimeo: false,
    updateVideoThumb: false,
    valid: true,
    videoFile: null,
    pdfFile: null,
    thumbFile: null,
    attachmentFiles: [],

    sending: false,

    removeVideo: false,
    removeThumb: false,
    removePDF: false,

    showProgress: false,
    uploadProgress: 0,
    textProgress: '',

    btnVideo: {
      title: 'Selecionar Vídeo',
      icon: false,
      color: 'default'
    },
    btnThumb: {
      title: 'Selecionar Thumbnail',
      icon: false,
      color: 'default'
    },
    btnPDF: {
      title: 'Selecionar PDF',
      icon: false,
      color: 'default'
    },

    isConnected: false,
  }),
  props: {
    content: {
      type: Object,
      required: true,
      default: function () {
        return {
          _id: {
            type: String,
            required: false
          },
          module: {
            type: String,
            required: false
          },
          course: {
            type: String,
            required: false
          },
          startAt: {
            type: String,
            required: false,
          },
          title: {
            type: String,
            required: true
          },
          summary: {
            type: String,
            required: false
          },
          vimeoId: {
            type: String,
            required: false
          },
          pdf: {
            type: String,
            required: false
          },
          attachments: {
            type: Array,
            required: false
          },
          thumb: {
            type: String,
            required: false
          },
          position: {
            type: Number,
            required: true
          },
          isPublic: {
            type: Boolean,
            required: false,
            default: false
          }
        }
      }
    }
  },
  watch: {
    show (value) {
      this.$emit('input', value)
    },
    videoFile (value) {
      if (value) {
        this.btnVideo.color = 'success'
      } else {
        this.btnVideo.color = 'default'
      }
    },
    pdfFile (value) {
      if (value) {
        this.btnPDF.color = 'success'
      } else {
        this.btnPDF.color = 'default'
      }
    },
    thumbFile (value) {
      if (value) {
        this.btnThumb.color = 'success'
      } else {
        this.btnThumb.color = 'default'
      }
    },
    startAt (val) {
      this.dateFormatted = this.formatDate(val)
    },
  },
  sockets: {
    connect () {
      // Fired when the socket connects.
      this.isConnected = true
    },

    disconnect () {
      this.isConnected = false
    },
    // Fired when the server sends something on the "socketProgressVimeo" channel.
    socketProgressVimeo (data) {
      this.uploadProgress = data.value
    }
  },
  created () {
    if (this.content.startAt) {
      this.startAt = new Date(this.content.startAt).toISOString().substr(0, 10)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    // getVimeoThumb (vimeoId) {
    //   this.btnLoadingThumbVimeo = true
    //   this.axios.get('/content/vimeo/thumb/' + vimeoId).then(response => {
    //     if (response.data.success) {
    //       this.content.thumb = response.data.url
    //       this.updateVideoThumb = true
    //     }
    //
    //     this.btnLoadingThumbVimeo = false
    //   })
    // },
    fileVideoChanged (file) {
      const ext = file.name.substr((file.name.lastIndexOf('.') + 1)).toLowerCase()

      if (ext !== 'mp4') {
        this.$swal('Apenas MP4', 'Vídeo somente no formato MP4', 'warning')

        return false
      }

      this.videoFile = file
    },
    filePDFChanged (file) {
      this.pdfFile = file
    },
    fileImageChanged (file) {
      this.thumbFile = file
      convertImage(file).then(base64 => {
        this.content.thumb = base64
      })
    },
    fileAttachmentsChanged (files) {
      this.attachmentFiles = files
    },
    uploadVideo (contentId) {
      return new Promise((resolve, reject) => {
        this.textProgress = 'Salvando vídeo'

        const formData = new FormData()

        formData.append('file', this.videoFile)
        formData.append('contentId', contentId)

        this.axios.post('/user/content/video', formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }).then(({ data }) => {
          if (data.success) {
            return resolve(data.content)
          }
        }).catch(reject)
      })
    },

    uploadThumb (contentId) {
      return new Promise((resolve, reject) => {
        this.textProgress = 'Salvando thumb'

        const formData = new FormData()

        formData.append('file', this.thumbFile)
        formData.append('contentId', contentId)

        this.axios.post('/user/content/thumb', formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }).then(({ data }) => {
          if (data.success) {
            return resolve(data.content)
          }
        }).catch(reject)
      })
    },

    uploadPDF (contentId) {
      return new Promise((resolve, reject) => {
        this.textProgress = 'Salvando PDF'

        const formData = new FormData()

        formData.append('file', this.pdfFile)
        formData.append('contentId', contentId)

        this.axios.post('/user/content/pdf', formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }).then(({ data }) => {
          if (data.success) {
            return resolve(data.content)
          }
        }).catch(reject)
      })
    },

    removeAttachment (attachment) {
      this.sending = true

      this.axios.post('/user/content/attachments/delete', {
        attachmentId: attachment._id
      }).then(({ data }) => {
        if (data.success) {
          this.$swal('Sucesso', 'Anexo removido com sucesso', 'success').then(() => {
            const index = this.content.attachments.findIndex(a => a._id === attachment._id)

            this.content.attachments.splice(index, 1)
          })
        } else {
          this.$swal('Ops', data.message || 'Erro ao remover', 'error')
        }
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Erro ao remover', 'error')
      }).finally(() => {
        this.sending = false
      })
    },

    downloadAttachment (attachment) {
      this.sending = true

      this.axios.request({
        method: 'get',
        url: `/user/content/file/${attachment.fileName}`,
        responseType: 'blob'
      }).then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${attachment.fileName}`)
        document.body.appendChild(link)
        link.click()
      }).finally(() => {
        this.sending = false
      })
    },

    renameAttachment (attachment) {
      this.sending = true

      this.axios.post('/user/content/attachments/rename', {
        attachmentId: attachment._id,
        name: attachment.name
      }).then(({ data }) => {
        if (data.success) {
          this.$swal('Sucesso', 'Anexo renomeado com sucesso', 'success')
        } else {
          this.$swal('Ops', data.message || 'Erro ao renomear', 'error')
        }
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Erro ao renomear', 'error')
      }).finally(() => {
        this.sending = false
      })
    },

    uploadAttachments (contentId) {
      return new Promise((resolve, reject) => {
        this.showProgress = true
        this.uploadProgress = 0
        this.textProgress = 'Salvando Anexos'

        const formData = new FormData()

        for (const attachmentFile of this.attachmentFiles) {
          formData.append('files', attachmentFile)
        }

        formData.append('contentId', contentId)

        this.axios.post('/user/content/attachments', formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }).then(({ data }) => {
          if (data.success) {
            return resolve(data.content)
          }
        }).catch(reject).finally(() => {
          this.showProgress = false
          this.uploadProgress = 0
          this.textProgress = ''
        })
      })
    },

    save () {
      if (this.$refs.formEditVideo.validate()) {
        this.content.type = 1
        this.content.startAt = this.startAt

        const data = {
          type: this.content.type,
          title: this.content.title,
          position: this.content.position,
          isPublic: this.content.isPublic,
          startAt: new Date(new Date(this.content.startAt).toLocaleString('en-US', { timeZone: 'UTC' })).toISOString(),
        }

        if (this.content.summary) {
          data.summary = this.content.summary
        }

        if (this.content.module) {
          data.module = this.content.module
        }

        if (this.content.course) {
          data.course = this.content.course
        }

        if (this.content._id) {
          data._id = this.content._id
        }

        if (this.content.description) {
          data.description = this.content.description
        }

        if (this.removeVideo) {
          data.removeVideo = this.removeVideo
        }

        if (this.removeThumb) {
          data.removeThumb = this.removeThumb
        }

        if (this.removePDF) {
          data.removePDF = this.removePDF
        }

        this.sending = true

        this.showProgress = true
        this.uploadProgress = 0

        this.axios.request({
          url: '/user/content',
          method: (this.content._id ? 'PUT' : 'POST'),
          data,
        }).then(({ data }) => {
          if (data.success) {
            let content = data.content

            const promises = []

            if (this.videoFile) {
              promises.push(this.uploadVideo(data.content._id))
            }

            if (this.thumbFile) {
              promises.push(this.uploadThumb(data.content._id))
            }

            if (this.pdfFile) {
              promises.push(this.uploadPDF(data.content._id))
            }

            if (this.attachmentFiles.length) {
              promises.push(this.uploadAttachments(data.content._id))
            }

            Promise.all(promises).then(results => {
              if (results.length) {
                results.sort((a, b) => {
                  return new Date(b.updatedAt) - new Date(a.updatedAt)
                })

                content = results[0]
              }

              this.$emit('save', content)

              this.show = false
            }).catch(err => {
              console.error(err)

              this.$swal(
                'Ops',
                'Erro ao salvar o conteúdo',
                'error'
              )
            }).finally(() => {
              this.sending = false

              this.showProgress = false
              this.uploadProgress = 0
              this.textProgress = ''
            })
          }
        })
      }
    }
  }
}
</script>
